export default "__VITE_ASSET__B6sRt$mH__"